/**
 * Healthcare Portal host for `@hsus-dev/session-policy` SessionWarningModal.
 *
 * - Wires MSAL logout + session teardown (`continueSession`, `endSession`).
 * - Maps HCP design tokens onto the package via `hcp-session-warning-bridge` (see sessionExpiredPortalBridge.css).
 */
import React from 'react';
import { SessionWarningModal as HsusSessionWarningModal } from '@hsus-dev/session-policy';
import { continueSession, endSession } from '../../services/session.service';
import { useLogout } from '../../modules/auth/hooks/useLogout';

export const SessionWarningModal: React.FC = () => {
  const { logout, isLoggingOut } = useLogout();

  return (
    <div className="hcp-session-warning-bridge">
      <HsusSessionWarningModal
        onContinueSession={continueSession}
        isSigningOut={isLoggingOut}
        onSignOut={async () => {
          await logout();
          endSession();
        }}
      />
    </div>
  );
};

